<div class="modal-header">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body thumbnail-files">
  <article>
    <figure class="card-image" *ngFor="let file of listFiles">
      <img class="thumbnail" [src]="getThumbnail(file)"  [alt]="file.name"  [title]="file.name">
      <div class="label-div">
        <div class="text-div">
          <span class="file-text">
            {{file.name}}
          </span>
          <span class="file-text">
            {{getSize(file.fileSize)}}
          </span>
        </div>
        <button>
          <span class="icon" (click)="download(file.id, file.name)" alt="Download do arquivo" title="Download do arquivo">download</span>
        </button>
      </div>
    </figure>
  </article>
</div>
<app-loading [loader]="isLoading"></app-loading>